import { useState } from "react";
import { Box } from "@mui/material";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import FooterInpho from "./FooterInpho";
import FooterCertificates from "./Certificate/FooterCertificates";
import FooterLinks from "./Links/FooterLinks";
import FooterNetworks from "./Networks/FooterNetworks";
import FooterLists from "./List/FooterLists";
import FooterCommunications from "./Communication/FooterCommunications";

export default function LandingFooterManage() {
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [expanded, setExpanded] = useState(
    location.state && location.state.expanded
      ? location.state.expanded
      : "panel9"
  );

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/landingmanagment",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/landingmanagment" },
          {
            name: "مدیریت فوتر",
            url: "/landingmanagment/footerManage",
          },
        ],
      }}
    >
      <Box>
        <FooterInpho />
      </Box>
    </Detail>
  );
}
